<template>
    <TairoCollapseLayout>
        <slot />
    </TairoCollapseLayout>
</template>
